import React from 'react';
import PropTypes from "prop-types";
import { CapsuleButton } from "../../../../../../../CommonComponents/Commons/commonComponents";
import { ComponentDivider, SelectDropdownStyles, CapsuleButtonWrapper } from '../styles';
import { Form, Row, Col } from 'antd';
import { addMutualFund } from "../../../actions";
import Notice from './Notice';
import { connect } from "react-redux";
import { ContentContainerSpaceSmall} from "../../../styles";
import { withRouter } from 'react-router-dom';
import VanguardAccountNumber from "../../CommonComponents/InputComponent/VanguardAccountNumber";
import DropDownComponent from "../../CommonComponents/DropDownComponent/DropDown";
import {defaultCheck} from "../../CommonComponents/Data";
import DonorDetails from "./DonorDetails";
import { recordError } from "../../../../../../../utils/commonUtil";
import { checkorEBTState } from "../../../selectors";

class CheckorEBT extends React.Component {
    constructor(props) {
        super(props);
        this.generateCheckData = this.generateCheckData.bind(this);
        this.addAnotherCheck = this.addAnotherCheck.bind(this);
    }

    addAnotherCheck = () => {
        try {
            let currentData = this.props.checkDetails;
            if (currentData.length < 20)
            {
            let data = JSON.parse(JSON.stringify(defaultCheck[0]));
            let loggedInAddress = this.props.loggedInAddress;
                data.Donors[0] = loggedInAddress;
            currentData.push(data);
            this.props.addMutualAccount(currentData);
            }
        } catch (error) {
          recordError(error);
        }
    }

    removeCheck = (index) => {
        try {
            let currentData = this.props.checkDetails;
            currentData.splice(index,1);
            this.props.addMutualAccount(currentData);
        } catch (error) {
          recordError(error);
        }
    }

    generateCheckData = (checks) => {
        let data = [];
        data = checks.map((check, index) => {
            return(<>
                <Row>
                    <Col lg={{span:8}} md={{span:8}}>
                        <SelectDropdownStyles>
                            <DropDownComponent assetHeld="checkOrEBT" accountId={index} contributionType="checkEBTList" label="Type of account in which assets are registered" traverse="corporateInformation" updateSelect="true" selected="checkSelected" giftLength={this.props.checkDetails.length-1} id={"selcheckEBTList"}/>
                        </SelectDropdownStyles>
                    </Col>
                </Row>
                { (check.type === "Other donor-advised fund") ?
                        <Row>
                        <Notice message={this.props.pageDetails.checkNotice} />
                        </Row>
                        : null
                    }
                { (check.type !== "Select Account Type") ?
                        <Row>
                        <DonorDetails assetHeld="checkOrEBT" accountId={index} contributionType="checkEBTList" type={check.type} count={this.props.checkDetails.length-1}/>
                        </Row>
                        : null
                    }
                <Row>
                    <Col lg={{ span: 8 }} md={{ span: 8 }}>
                        <VanguardAccountNumber assetHeld="checkOrEBT" property="amount" label="Contribution amount" accountId={index} selected="checkSelected" contributionType="checkEBTList" giftLength={this.props.checkDetails.length-1} id={"txtContributionAmoun"}/>
                    </Col>
                </Row>
                {(index !== 0) ?
                    <CapsuleButtonWrapper marginBottom="30px">
                    <CapsuleButton
                        data-test="checkorEBTCapsule1"
                        text= "Remove Check"
                        id={"button"+index} 
                        onClick={e => this.removeCheck(index)}
                    />
                    </CapsuleButtonWrapper>
                    : null
                }
                {((index) < (checks.length-1)) ?
                    <ComponentDivider marginTop="0px" marginBottom="40px" mT="0px" mB="40px"/>
                    : null
                }
            </>)
        });
        return data;
    }

    render() {
        return (
            <ContentContainerSpaceSmall data-test="checkorEBT">
                <div className="fluid">
            <Form hideRequiredMark>
            <div className={this.props.isBlock !== 'none' ? 'block' : 'display-none' }>
                {this.generateCheckData(this.props.checkDetails)}
                <>
                     <CapsuleButtonWrapper marginBottom="30px">
                     <CapsuleButton
                        data-test="checkorEBTCapsule0"
                        text= "Add another account Check/EBT"
                        iconType="add"
                        padding="5px 20px"
                        disabled={this.props.checkDetails.length === 20 ? true : false} 
                        onClick={e => this.addAnotherCheck(e)} 
                        id={"btnAddAnotherAccountCheck"}
                    />
                    </CapsuleButtonWrapper>
                </>
                </div>
            </Form>
            </div>
            </ContentContainerSpaceSmall>
        )
    }
}

const WrappedCheckorEBT = Form.create({ name: "AssetHeldOutsideVanguard" })(CheckorEBT);

WrappedCheckorEBT.propTypes = {
    checkDetails: PropTypes.array,
    loggedInAddress: PropTypes.object,
    pageDetails: PropTypes.object,
    addMutualAccount: PropTypes.func,
}

const mapStateToProps = state => ({
    ...checkorEBTState(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
    addMutualAccount: arr => dispatch(addMutualFund({value: arr, contributionType: "checkEBTList", assetHeld:"checkOrEBT", selected:'checkSelected'})),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedCheckorEBT));